import {
  hasEnteredValue,
  hasEnteredTrimmedValue,
} from "@validationUtility";
import {
  IPackagingFieldsConfig,
  IFieldConfig,
  isPackageDetailsRowField,
  PACKAGING_FIELDS,
} from "./types";

export const getPackageRowModelKey = (fieldCfg: IFieldConfig): string =>
  fieldCfg.dataKey ?? fieldCfg.field;

const hasEnteredRowFieldValue = (
  fieldCfg: IFieldConfig,
  value: unknown
): boolean => {
  if (
    fieldCfg.field === PACKAGING_FIELDS.PACKAGE_TYPE ||
    fieldCfg.dataKey === "packageCode"
  ) {
    return hasEnteredTrimmedValue(value);
  }
  return hasEnteredValue(value);
};

/** Drop placeholder rows only — keep when any visible config row field has a value. */
export const shouldRetainPackageRow = (
  packageRow: Record<string, unknown>,
  packagingConfig: IPackagingFieldsConfig
): boolean => {
  const visibleRowFields = packagingConfig.fieldOrder
    .map((field) => packagingConfig.fieldMap[field])
    .filter(
      (cfg): cfg is IFieldConfig =>
        Boolean(cfg?.visible && isPackageDetailsRowField(cfg))
    );

  if (visibleRowFields.length === 0) {
    return true;
  }

  return visibleRowFields.some((cfg) =>
    hasEnteredRowFieldValue(cfg, packageRow[getPackageRowModelKey(cfg)])
  );
};
